<template>
  <div class="key-words">
    <el-dialog
      title="关键词屏蔽"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div class="header-form">
        <el-form
          ref="formTool"
          label-width="82px"
          :model="formTool"
          :inline="true"
          size="small"
        >
          <el-form-item label="">
            <el-input
              v-model="formTool.filterWords"
              placeholder="请输入关键词"
              @input="handleSearch"
              clearable
            />
          </el-form-item>
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSearch"
              >搜索</el-button
            >
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleReset"
              >重置</el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="onAddKeyWords"
              >添加关键词</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="key-words-table">
        <MyTable
          :table-data="tableData"
          :page="page"
          :index="false"
          :table-option.sync="tableOption"
          @page-change="getKeyWordsList"
          v-loading="listLoading"
        >
          <!-- <template slot="enableStatus" slot-scope="scope">
            <el-switch
              v-model="scope.row.enableStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="handleKeyWordStatus(scope.row, $event)"
            ></el-switch>
          </template> -->
          <template slot="operation" slot-scope="scope">
            <el-button
              type="primary"
              @click="handleDeleteKeyWords(scope.row)"
            >删除</el-button>
          </template>
        </MyTable>
      </div>
    </el-dialog>
    <el-dialog
      title="添加关键词"
      :visible.sync="addDlgVisible"
      width="80%"
      :before-close="handleAddClose"
      append-to-body
    >
      <div>
        <el-form ref="keyForm" :inline="true" size="small">
          <el-form-item label="关键词">
            <el-input
              v-model="newKeyWord"
              placeholder="请输入关键词"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="addDlgVisible = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="handleAddKeyword"
           v-loading="addLoading"
            >提交</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/** 关键词屏蔽 */
import MyTable from "@/components/myTable";
import {
  addSearchKeywordsFilter,
  searchKeywordsList,
  updateSearchKeywords,
  deleteSearchKeywords,
} from "@/api/statistics";

export default {
  name: "KeyWords",
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      tableOption: [
        {
          label: "关键词",
          prop: "filterWords",
        },
        // {
        //   label: "是否屏蔽",
        //   prop: "enableStatus",
        //   slot: true,
        // },
        {
          label: "操作",
          prop: "operation",
          slot: true,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 30,
        pageSizes: [30, 50, 100, 500],
      },
      formTool: {
        filterWords: "",
      },
      addDlgVisible: false,
      listLoading: false,
      addLoading: false,
      newKeyWord: "",
    };
  },
  components: { MyTable },
  mounted() {},
  methods: {
    init() {
      this.dialogVisible = true;
      this.getKeyWordsList();
    },
    onAddKeyWords() {
      // this.$refs.keyForm && this.$refs.keyForm.resetFields()
      // this.newKeyWord = ''
      // this.addDlgVisible = true;
      if(!this.formTool.filterWords || !this.formTool.filterWords.trim()){
        this.$message.warning('请输入需要添加的屏蔽词')
        return;
      }
      this.handleAddKeyword()
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close')
    },
    handleAddClose() {
      this.addDlgVisible = false;
    },
    //输入搜索
    handleSearch(val) {
      this.getKeyWordsList();
    },
    handleReset() {
      this.$refs.formTool && this.$refs.formTool.resetFields();
      this.handleSearch();
    },
    handleKeyWordStatus(row,status) {
      console.log('row', row,e);
      this.$confirm(
        `确定${status ? "屏蔽" : "解除屏蔽"}该关键词吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          //
          updateSearchKeywords({
            enableStatus: status ? 1 : 0,
            id: row.id,
          }).then((res) => {
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.enableStatus = !status;
        });
    },
    //获取列表
    getKeyWordsList(params) {
      console.log("getKeyWordsList----", params, this.page);
      let { size, current } = this.page;
      this.listLoading = true
      searchKeywordsList({
        filterWords: this.formTool.filterWords,
        size,
        current,
      }).then((res) => {
        if (res && res.records) {
          res.records.forEach(
            (item) =>
              (item.enableStatus = item.enableStatus == 1 ? true : false)
          );
          this.tableData = res.records;
          this.page.total = res.total;
        }
      }).finally(() => this.listLoading = false)
    },
    // 添加关键词
    handleAddKeyword() {
      this.addLoading = true
      addSearchKeywordsFilter({
        filterWords: this.formTool.filterWords,
      })
        .then(() => {
          this.$message.success("添加成功");
          this.formTool.filterWords = ''
          this.handleSearch();
        })
        .finally(() => {
           this.addDlgVisible = false;
           this.addLoading = false
        });
    },
    // 删除关键词
    handleDeleteKeyWords(row) {
      this.$confirm(`确定删除该关键词吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //
          deleteSearchKeywords(row.id).then((res) => {
            this.$message.success("操作成功");
            this.handleSearch();
          });
        })
        .catch(() => {
          row.enableStatus = !row.enableStatus;
        });
    },
  },
};
</script>